export default __webpack_public_path__ + "media/images/dog-1-d72b3989e3d3c62317676a6e12af343e.png";